function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExeloo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "522px",
    height: "477px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M -0.5,-0.5 C 173.5,-0.5 347.5,-0.5 521.5,-0.5C 521.5,158.5 521.5,317.5 521.5,476.5C 347.5,476.5 173.5,476.5 -0.5,476.5C -0.5,317.5 -0.5,158.5 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#20a265",
    d: "M 317.5,17.5 C 316.507,54.4272 316.173,91.4272 316.5,128.5C 305.833,128.5 295.167,128.5 284.5,128.5C 284.784,126.585 284.451,124.919 283.5,123.5C 281.086,114.922 275.419,109.422 266.5,107C 220.501,106.5 174.501,106.333 128.5,106.5C 128.333,81.4978 128.5,56.4978 129,31.5C 131.106,25.7284 134.939,21.5617 140.5,19C 199.441,17.5117 258.441,17.0117 317.5,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#32c280",
    d: "M 317.5,17.5 C 371.501,17.3333 425.501,17.5 479.5,18C 487.673,19.6743 492.673,24.5076 494.5,32.5C 494.5,64.5 494.5,96.5 494.5,128.5C 435.5,128.5 376.5,128.5 317.5,128.5C 317.167,128.5 316.833,128.5 316.5,128.5C 316.173,91.4272 316.507,54.4272 317.5,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1d925b",
    d: "M 128.5,106.5 C 174.501,106.333 220.501,106.5 266.5,107C 275.419,109.422 281.086,114.922 283.5,123.5C 283.5,125.167 283.5,126.833 283.5,128.5C 279.5,128.5 275.5,128.5 271.5,128.5C 269.359,125.528 266.692,123.028 263.5,121C 261.559,119.097 259.226,118.264 256.5,118.5C 216.5,117.167 176.5,117.167 136.5,118.5C 133.794,118.425 131.127,118.092 128.5,117.5C 128.5,113.833 128.5,110.167 128.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#19854d",
    d: "M 128.5,117.5 C 131.127,118.092 133.794,118.425 136.5,118.5C 148.53,118.541 160.53,118.874 172.5,119.5C 121.033,149.737 69.3658,179.737 17.5,209.5C 17.3334,183.831 17.5,158.165 18,132.5C 20.277,124.556 25.4437,119.722 33.5,118C 65.1649,117.5 96.8316,117.333 128.5,117.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#58a47d",
    d: "M 136.5,118.5 C 176.5,117.167 216.5,117.167 256.5,118.5C 253.941,118.198 251.607,118.532 249.5,119.5C 223.804,118.175 198.137,118.175 172.5,119.5C 160.53,118.874 148.53,118.541 136.5,118.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#148046",
    d: "M 249.5,119.5 C 254.451,121.452 258.117,124.785 260.5,129.5C 261.15,131.435 261.483,133.435 261.5,135.5C 261.5,151.167 261.5,166.833 261.5,182.5C 226.838,201.16 192.838,220.826 159.5,241.5C 158.291,239.565 158.458,237.565 160,235.5C 172.5,215.167 185,194.833 197.5,174.5C 187.851,173.335 178.184,173.168 168.5,174C 159.46,190.581 150.293,207.081 141,223.5C 132.833,207.167 124.667,190.833 116.5,174.5C 105.833,173.167 95.1667,173.167 84.5,174.5C 97.1023,196.429 110.102,218.095 123.5,239.5C 115.833,251.813 107.833,263.813 99.5,275.5C 72.6096,290.378 45.9429,305.712 19.5,321.5C 18.8281,322.949 18.1614,324.282 17.5,325.5C 17.5,286.833 17.5,248.167 17.5,209.5C 69.3658,179.737 121.033,149.737 172.5,119.5C 198.137,118.175 223.804,118.175 249.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1d6340",
    d: "M 249.5,119.5 C 251.607,118.532 253.941,118.198 256.5,118.5C 259.226,118.264 261.559,119.097 263.5,121C 266.692,123.028 269.359,125.528 271.5,128.5C 271.5,128.833 271.5,129.167 271.5,129.5C 271.5,129.833 271.5,130.167 271.5,130.5C 267.936,129.577 264.269,129.244 260.5,129.5C 258.117,124.785 254.451,121.452 249.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#55bc8c",
    d: "M 494.5,32.5 C 495.499,101.331 495.833,170.331 495.5,239.5C 495.167,239.5 494.833,239.5 494.5,239.5C 494.5,202.833 494.5,166.167 494.5,129.5C 435.5,129.5 376.5,129.5 317.5,129.5C 317.5,129.167 317.5,128.833 317.5,128.5C 376.5,128.5 435.5,128.5 494.5,128.5C 494.5,96.5 494.5,64.5 494.5,32.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#094826",
    d: "M 260.5,129.5 C 264.269,129.244 267.936,129.577 271.5,130.5C 271.433,131.959 271.766,133.292 272.5,134.5C 272.5,169.5 272.5,204.5 272.5,239.5C 269.167,239.5 265.833,239.5 262.5,239.5C 262.832,204.663 262.498,169.996 261.5,135.5C 261.483,133.435 261.15,131.435 260.5,129.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0d6f3a",
    d: "M 271.5,129.5 C 275.5,129.5 279.5,129.5 283.5,129.5C 283.5,166.167 283.5,202.833 283.5,239.5C 280.167,239.5 276.833,239.5 273.5,239.5C 273.832,204.329 273.498,169.329 272.5,134.5C 271.766,133.292 271.433,131.959 271.5,130.5C 271.5,130.167 271.5,129.833 271.5,129.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#429769",
    d: "M 283.5,123.5 C 284.451,124.919 284.784,126.585 284.5,128.5C 295.167,128.5 305.833,128.5 316.5,128.5C 316.833,128.5 317.167,128.5 317.5,128.5C 317.5,128.833 317.5,129.167 317.5,129.5C 317.5,165.833 317.5,202.167 317.5,238.5C 316.502,202.337 316.168,166.004 316.5,129.5C 305.833,129.5 295.167,129.5 284.5,129.5C 284.5,166.167 284.5,202.833 284.5,239.5C 284.167,239.5 283.833,239.5 283.5,239.5C 283.5,202.833 283.5,166.167 283.5,129.5C 279.5,129.5 275.5,129.5 271.5,129.5C 271.5,129.167 271.5,128.833 271.5,128.5C 275.5,128.5 279.5,128.5 283.5,128.5C 283.5,126.833 283.5,125.167 283.5,123.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0f7b40",
    d: "M 317.5,238.5 C 317.5,238.833 317.5,239.167 317.5,239.5C 306.5,239.5 295.5,239.5 284.5,239.5C 284.5,202.833 284.5,166.167 284.5,129.5C 295.167,129.5 305.833,129.5 316.5,129.5C 316.168,166.004 316.502,202.337 317.5,238.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#20a264",
    d: "M 317.5,129.5 C 376.5,129.5 435.5,129.5 494.5,129.5C 494.5,166.167 494.5,202.833 494.5,239.5C 435.5,239.5 376.5,239.5 317.5,239.5C 317.5,239.167 317.5,238.833 317.5,238.5C 317.5,202.167 317.5,165.833 317.5,129.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfcfb",
    d: "M 159.5,241.5 C 166.013,253.204 173.013,264.538 180.5,275.5C 186.247,286.07 192.58,296.237 199.5,306C 188.839,306.5 178.172,306.667 167.5,306.5C 165.029,300.224 162.029,294.224 158.5,288.5C 152.359,276.887 146.192,265.22 140,253.5C 130.726,271.056 121.226,288.389 111.5,305.5C 101.319,305.827 91.3194,305.494 81.5,304.5C 87.7615,294.973 93.7615,285.306 99.5,275.5C 107.833,263.813 115.833,251.813 123.5,239.5C 110.102,218.095 97.1023,196.429 84.5,174.5C 95.1667,173.167 105.833,173.167 116.5,174.5C 124.667,190.833 132.833,207.167 141,223.5C 150.293,207.081 159.46,190.581 168.5,174C 178.184,173.168 187.851,173.335 197.5,174.5C 185,194.833 172.5,215.167 160,235.5C 158.458,237.565 158.291,239.565 159.5,241.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#137a40",
    d: "M 261.5,182.5 C 261.249,197.646 261.249,212.646 261.5,227.5C 234.299,243.263 207.299,259.263 180.5,275.5C 173.013,264.538 166.013,253.204 159.5,241.5C 192.838,220.826 226.838,201.16 261.5,182.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4f8869",
    d: "M 261.5,135.5 C 262.498,169.996 262.832,204.663 262.5,239.5C 262.167,239.5 261.833,239.5 261.5,239.5C 261.5,235.5 261.5,231.5 261.5,227.5C 261.249,212.646 261.249,197.646 261.5,182.5C 261.5,166.833 261.5,151.167 261.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#10733c",
    d: "M 261.5,227.5 C 261.5,231.5 261.5,235.5 261.5,239.5C 261.5,251.167 261.5,262.833 261.5,274.5C 210.896,302.804 160.562,331.637 110.5,361C 116.157,361.499 121.824,361.666 127.5,361.5C 127.5,361.833 127.5,362.167 127.5,362.5C 95.802,362.811 64.1354,362.478 32.5,361.5C 35.3237,358.535 38.657,356.035 42.5,354C 80.7486,331.96 118.915,309.793 157,287.5C 157.383,288.056 157.883,288.389 158.5,288.5C 162.029,294.224 165.029,300.224 167.5,306.5C 178.172,306.667 188.839,306.5 199.5,306C 192.58,296.237 186.247,286.07 180.5,275.5C 207.299,259.263 234.299,243.263 261.5,227.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#42996a",
    d: "M 317.5,240.5 C 317.5,240.167 317.5,239.833 317.5,239.5C 376.5,239.5 435.5,239.5 494.5,239.5C 494.833,239.5 495.167,239.5 495.5,239.5C 495.5,276.5 495.5,313.5 495.5,350.5C 495.167,350.5 494.833,350.5 494.5,350.5C 494.5,313.833 494.5,277.167 494.5,240.5C 435.5,240.5 376.5,240.5 317.5,240.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0d341f",
    d: "M 272.5,240.5 C 272.81,280.524 272.477,320.524 271.5,360.5C 268.358,366.311 263.691,370.311 257.5,372.5C 254.615,372.806 251.948,372.473 249.5,371.5C 258.331,366.176 261.997,358.51 260.5,348.5C 260.833,347.167 261.167,345.833 261.5,344.5C 262.498,310.004 262.832,275.337 262.5,240.5C 265.833,240.5 269.167,240.5 272.5,240.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4b735d",
    d: "M 272.5,240.5 C 272.833,240.5 273.167,240.5 273.5,240.5C 273.832,286.336 273.499,332.003 272.5,377.5C 272.822,371.642 272.489,365.975 271.5,360.5C 272.477,320.524 272.81,280.524 272.5,240.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#155231",
    d: "M 273.5,240.5 C 276.833,240.5 280.167,240.5 283.5,240.5C 283.5,282.833 283.5,325.167 283.5,367.5C 281.727,373.344 278.227,378.011 273,381.5C 272.517,380.552 272.351,379.552 272.5,378.5C 272.5,378.167 272.5,377.833 272.5,377.5C 273.499,332.003 273.832,286.336 273.5,240.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#175c37",
    d: "M 495.5,351.5 C 495.667,382.835 495.5,414.168 495,445.5C 492.719,454.781 486.886,460.281 477.5,462C 366.5,462.667 255.5,462.667 144.5,462C 136.632,459.465 131.465,454.299 129,446.5C 128.5,429.503 128.333,412.503 128.5,395.5C 170.835,395.667 213.168,395.5 255.5,395C 262.105,393.53 267.105,389.863 270.5,384C 270.272,383.601 269.938,383.435 269.5,383.5C 270.767,381.961 271.767,380.294 272.5,378.5C 272.351,379.552 272.517,380.552 273,381.5C 278.227,378.011 281.727,373.344 283.5,367.5C 284.499,325.337 284.832,283.003 284.5,240.5C 295.167,240.5 305.833,240.5 316.5,240.5C 316.5,277.5 316.5,314.5 316.5,351.5C 376.167,351.5 435.833,351.5 495.5,351.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4b8867",
    d: "M 272.5,134.5 C 273.498,169.329 273.832,204.329 273.5,239.5C 276.833,239.5 280.167,239.5 283.5,239.5C 283.833,239.5 284.167,239.5 284.5,239.5C 295.5,239.5 306.5,239.5 317.5,239.5C 317.5,239.833 317.5,240.167 317.5,240.5C 317.5,277.167 317.5,313.833 317.5,350.5C 376.5,350.5 435.5,350.5 494.5,350.5C 494.833,350.5 495.167,350.5 495.5,350.5C 495.5,350.833 495.5,351.167 495.5,351.5C 435.833,351.5 376.167,351.5 316.5,351.5C 316.5,314.5 316.5,277.5 316.5,240.5C 305.833,240.5 295.167,240.5 284.5,240.5C 284.832,283.003 284.499,325.337 283.5,367.5C 283.5,325.167 283.5,282.833 283.5,240.5C 280.167,240.5 276.833,240.5 273.5,240.5C 273.167,240.5 272.833,240.5 272.5,240.5C 272.5,240.167 272.5,239.833 272.5,239.5C 272.5,204.5 272.5,169.5 272.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#107b3f",
    d: "M 317.5,240.5 C 376.5,240.5 435.5,240.5 494.5,240.5C 494.5,277.167 494.5,313.833 494.5,350.5C 435.5,350.5 376.5,350.5 317.5,350.5C 317.5,313.833 317.5,277.167 317.5,240.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0f6e37",
    d: "M 261.5,274.5 C 261.229,289.979 261.229,305.312 261.5,320.5C 237.563,333.47 213.896,346.97 190.5,361C 169.503,361.5 148.503,361.667 127.5,361.5C 121.824,361.666 116.157,361.499 110.5,361C 160.562,331.637 210.896,302.804 261.5,274.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#167a41",
    d: "M 158.5,288.5 C 157.883,288.389 157.383,288.056 157,287.5C 118.915,309.793 80.7486,331.96 42.5,354C 38.657,356.035 35.3237,358.535 32.5,361.5C 24.4531,359.62 19.6198,354.62 18,346.5C 17.5004,339.508 17.3337,332.508 17.5,325.5C 18.1614,324.282 18.8281,322.949 19.5,321.5C 45.9429,305.712 72.6096,290.378 99.5,275.5C 93.7615,285.306 87.7615,294.973 81.5,304.5C 80.7109,304.783 80.0442,305.283 79.5,306C 90.3414,306.825 101.008,306.659 111.5,305.5C 121.226,288.389 130.726,271.056 140,253.5C 146.192,265.22 152.359,276.887 158.5,288.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4b765e",
    d: "M 261.5,239.5 C 261.833,239.5 262.167,239.5 262.5,239.5C 265.833,239.5 269.167,239.5 272.5,239.5C 272.5,239.833 272.5,240.167 272.5,240.5C 269.167,240.5 265.833,240.5 262.5,240.5C 262.832,275.337 262.498,310.004 261.5,344.5C 261.5,336.5 261.5,328.5 261.5,320.5C 261.229,305.312 261.229,289.979 261.5,274.5C 261.5,262.833 261.5,251.167 261.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8fbfa4",
    d: "M 81.5,304.5 C 91.3194,305.494 101.319,305.827 111.5,305.5C 101.008,306.659 90.3414,306.825 79.5,306C 80.0442,305.283 80.7109,304.783 81.5,304.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#176936",
    d: "M 261.5,320.5 C 261.5,328.5 261.5,336.5 261.5,344.5C 261.167,345.833 260.833,347.167 260.5,348.5C 257.759,356.042 252.426,360.542 244.5,362C 205.835,362.5 167.168,362.667 128.5,362.5C 128.167,362.5 127.833,362.5 127.5,362.5C 127.5,362.167 127.5,361.833 127.5,361.5C 148.503,361.667 169.503,361.5 190.5,361C 213.896,346.97 237.563,333.47 261.5,320.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0b2a1a",
    d: "M 260.5,348.5 C 261.997,358.51 258.331,366.176 249.5,371.5C 209.197,372.483 168.864,372.816 128.5,372.5C 128.5,369.167 128.5,365.833 128.5,362.5C 167.168,362.667 205.835,362.5 244.5,362C 252.426,360.542 257.759,356.042 260.5,348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#114127",
    d: "M 271.5,360.5 C 272.489,365.975 272.822,371.642 272.5,377.5C 272.5,377.833 272.5,378.167 272.5,378.5C 271.767,380.294 270.767,381.961 269.5,383.5C 269.167,383.5 268.833,383.5 268.5,383.5C 222.167,383.5 175.833,383.5 129.5,383.5C 129.5,380.167 129.5,376.833 129.5,373.5C 172.337,373.832 215.003,373.499 257.5,372.5C 263.691,370.311 268.358,366.311 271.5,360.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3a5848",
    d: "M 249.5,371.5 C 251.948,372.473 254.615,372.806 257.5,372.5C 215.003,373.499 172.337,373.832 129.5,373.5C 129.167,373.5 128.833,373.5 128.5,373.5C 128.5,373.167 128.5,372.833 128.5,372.5C 168.864,372.816 209.197,372.483 249.5,371.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#49715b",
    d: "M 128.5,373.5 C 128.833,373.5 129.167,373.5 129.5,373.5C 129.5,376.833 129.5,380.167 129.5,383.5C 175.833,383.5 222.167,383.5 268.5,383.5C 222.003,384.499 175.336,384.832 128.5,384.5C 128.5,380.833 128.5,377.167 128.5,373.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#134a2c",
    d: "M 268.5,383.5 C 268.833,383.5 269.167,383.5 269.5,383.5C 269.938,383.435 270.272,383.601 270.5,384C 267.105,389.863 262.105,393.53 255.5,395C 213.168,395.5 170.835,395.667 128.5,395.5C 128.5,391.833 128.5,388.167 128.5,384.5C 175.336,384.832 222.003,384.499 268.5,383.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExeloo);
export default __webpack_public_path__ + "static/media/exeloo.76b7cb661d7897e3d3a777806e25efe7.svg";
export { ForwardRef as ReactComponent };